import './App.css';
import DrawerAppBar from './components/DrawerAppBar';
import DowndloadSection from './components/DownloadSection';
import OverviewProductSection from './components/OverviewProductSection';
import FeaturesSection from './components/FeaturesSection';
import TeamSection from './components/TeamSection';
import { Box } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import { db } from './initialFirebase'
import { collection, getDocs } from 'firebase/firestore';
import FeedbackSection from './components/FeedbackSection';
import { initializeAuth } from './initialFirebase'

function App() {
  const [urlDownload, setUrlDownload] = useState('')
  const feedBackSectionRef = useRef(null);

  useEffect(() => {
    const releaseCollectionRef = collection(db, 'release_xml')
    getDocs(releaseCollectionRef).then(response => {
      setUrlDownload(response.docs[0].data().url)
    })
  }, [])

  useEffect(() => {
    initializeAuth()
  }, [])

  const onClickFeedbackButton = () => {
    feedBackSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <DrawerAppBar onClickFeedbackButton={onClickFeedbackButton} />
      <DowndloadSection urlDownload={urlDownload} />
      <OverviewProductSection />
      <FeaturesSection />
      <FeedbackSection feedBackSectionRef={feedBackSectionRef} />
      <TeamSection />
    </Box>
  )
}

export default App;
